import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink as RouterNavLink } from 'react-router-dom'; // Import Link and NavLink
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/images/logo.png';

const Header = () => {
    const { t, i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <header className="w-100 float-left header-con position-relative main-box">
            <Container>
                <Navbar expand="lg" variant="light">
                    <Navbar.Brand href="/">
                        <img src={logo} alt="logo-icon" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarSupportedContent" />
                    <Navbar.Collapse id="navbarSupportedContent">
                        <Nav className="ms-auto">
                            <Nav.Link as={RouterNavLink} to="/" end>{t('nav_home')}</Nav.Link>
                            <Nav.Link as={RouterNavLink} to="/about">{t('nav_about')}</Nav.Link>
                            <Nav.Link as={RouterNavLink} to="/services">{t('nav_services')}</Nav.Link>
                            <Nav.Link as={RouterNavLink} to="/pricing">{t('nav_pricing')}</Nav.Link> {/* <-- ADD THIS LINE */}
                            <Nav.Link as={RouterNavLink} to="/contact">{t('nav_contact')}</Nav.Link> {/* <-- ADD THIS LINE */}
                            {/* <Nav.Item className="free-trial">
                               <Nav.Link href="/contact" className="font-weight-bold">{t('nav_try_free')}</Nav.Link>
                            </Nav.Item> */}
                        </Nav>
                        <div className="header-contact">
                            <ul className="list-unstyled mb-0 d-flex align-items-center">
                                <li className="d-inline-block">
                                    <Link to="/login" className="contact-btn d-inline-block">{t('nav_login')}</Link>
                                    {/* <a href="/contact" className="contact-btn d-inline-block">{t('nav_contact')}</a> */}
                                </li>
                                <li className="d-inline-block ms-3">
                                    <NavDropdown 
                                        title={<FontAwesomeIcon icon={faGlobe} size="lg" />} 
                                        id="language-switcher-dropdown" 
                                        align="end"
                                    >
                                        <NavDropdown.Item onClick={() => changeLanguage('en')}>English</NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => changeLanguage('ar')}>العربية</NavDropdown.Item>
                                    </NavDropdown>
                                </li>
                            </ul>
                        </div>
                    </Navbar.Collapse>
                </Navbar>
            </Container>
        </header>
    );
};

export default Header;